import { FC } from 'react';

import { IdentityUserSearchBox } from './IdentityUserSearchBox';
import { IdentityUserSearchResult } from './IdentityUserSearchBoxOptions';

type Props = {
  // eslint-disable-next-line no-unused-vars
  onSearchCompleted: (result: IdentityUserSearchResult) => void;
  showLabel?: boolean;
};

export const IdentityUserSearchBoxContainer: FC<Props> = ({
  onSearchCompleted,
  showLabel,
}) => {
  return (
    <IdentityUserSearchBox
      onSelected={onSearchCompleted}
      showLabel={showLabel}
    />
  );
};
